import { FORTA_BLUE, FORTA_ERROR } from '../../../../../utils/colors';

export const EVV_QR_DIALOG_SX = {
  width: 474,
  maxWidth: '96vw',
  height: 'auto',
  maxHeight: '96vh',
  p: 3,
  border: `1px solid ${FORTA_BLUE.light2}`,
};

export const EVV_QR_TITLE_SX = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.5,
};

export const EVV_QR_TITLE_TEXT_SX = {
  fontSize: 16,
  fontWeight: 500,
  lineHeight: 1.4,
};

export const EVV_QR_CODE_SX = {
  display: 'flex',
  justifyContent: 'center',
  my: 3,
};

export const EVV_QR_FALLBACK_BOX_SX = {
  border: `1px solid ${FORTA_BLUE.light2}`,
  borderRadius: '8px',
  px: 1.5,
  py: 1,
};

export const EVV_QR_FALLBACK_ROW_SX = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 3,
  mt: 1.5,
  mb: 1,
};

export const EVV_QR_REASON_SELECT_SX = {
  width: 240,
  flexShrink: 0,
};

export const EVV_QR_LOCATION_ERROR_SX = {
  color: FORTA_ERROR,
  fontSize: 14,
  mb: 1,
};

export const EVV_QR_FOOTER_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mt: 2,
};

export const EVV_QR_COUNTDOWN_SX = {
  fontSize: 16,
  fontWeight: 500,
  fontVariantNumeric: 'tabular-nums',
};
